import state from "./register.state";
import actions from "./register.actions";

export default {
  namespaced: true,
  state,
  actions,
};
